module.exports = __webpack_public_path__ + "img/1762863279274-4zAA05qy.81f4949b.png";